<div class="container">
    <div>La souscription de vos contrats d'assurance à Auxerre</div>
    <div>Nous intervenons dans un rayon de 30 km autour d'Auxerre afin de vous permettre d'être couvert face à tous les accidents de la vie courante.
        Depuis plusieurs années, nous vous accompagnons dans toutes les étapes et les démarches relatives à la <span>souscription de votre contrat</span>  et à vos demandes d'indemnisation.</div>
    <div>Votre courtier</div>
</div>